<script lang="ts" setup>
import { computed, inject, onMounted } from 'vue';

// COMPONENTS
import GStepGrid from '@/components/GStepper/components/GStepGrid.vue';
import GProductCard from '@/components/GProductCard.vue';
import { GButton } from '@flash-global66/g-button';

// PROVIDERS
import transactionProvider, {
  initialValuesCashInProvider,
} from '@/modules/cashIn/config/cashInProvider';

// COMPOSABLES
import { useRouter } from 'vue-router';
import { useQueryURL } from '@/composables/useQueryURL';
import { useProductCards } from '@/composables/useProductCards';

// STORE
import { useAccountStore } from '@/stores/account';
import { useWalletStore } from '@/stores/wallet';

// HELPERS
import { defaultMessageByCountry } from '../../helpers/defaultSLA';
import productCards from '@/helpers/constants/productCards';
import { getAsset } from '@/helpers/assets';
import { cashInValidationCl } from '../../helpers/cashInValidationCl';

const router = useRouter();
const storeAccount = useAccountStore();
const storeWallet = useWalletStore();
const { showProducts } = useProductCards({
  include: ['CARD', 'P2P', 'REMITTANCE']
});

const transactionInject = inject(
  transactionProvider,
  initialValuesCashInProvider
);

const { transactionData, originRoute } = transactionInject;

const messageSLA = computed(() => {
  return defaultMessageByCountry(
    storeAccount.kycStatus?.company?.addressCountry?.country
  );

  // --- COMMENTED LOGIC UNTIL NEED
  // const { slaDeadlineDate, slaDeadlineDateMillis } = transactionData.value;

  // if (slaDeadlineDate || slaDeadlineDateMillis) {
  //   let slaDate: string | number = Date.now();
  //   if (slaDeadlineDate) slaDate = slaDeadlineDate;
  //   else if (slaDeadlineDateMillis) slaDate = slaDeadlineDateMillis;

  //   const date = new Date(slaDate).toLocaleDateString();

  //   return `Tu dinero debería acreditarse el ${date}`;
  // } else {
  //   return defaultMessageByCountry(
  //     storeAccount.kycStatus?.company?.addressCountry?.country
  //   );
  // }
});

const showSla = computed(
  () =>
    !cashInValidationCl({
      countryCode: originRoute.value.country.alpha2Code,
      isGlobalCard: storeWallet.isGlobalCard,
      payment: transactionData.value.paymentMethod?.name || '',
    })
);

const onHome = () => {
  router.push({ name: 'movements' });
};

onMounted(async () => {
  useQueryURL({ cashin: 'success' });
});
</script>

<template>
  <GStepGrid maxWidth="max-w-5xl" hide-buttons>
    <template #content>
      <div class="flex flex-row w-[95%] justify-center mt-8 gap-8">
        <section
          class="flex flex-col items-center w-full h-fit mb-8 p-6 pt-10 gap-8 bg-gray-11 sm:w-1/2 sm:rounded-md sm:shadow-sm sm:shadow-blue-15/15"
        >
          <div class="mb-none">
            <img
              class="w-[112px] h-[112px]"
              :src="getAsset('img/world-hand-money.png')"
            />
          </div>
          <h1 class="text-8 text-center text-gray-2 font-semibold">
            ¡Listo! Estamos procesando la carga de dinero
          </h1>
          <p class="text-5 text-center text-blue-11 font-medium">
            Pronto tendrás el dinero en tu cuenta
          </p>
          <div
            v-if="showSla"
            class="flex gap-4 w-full bg-green-9 text-blue-14 text-3 font-medium p-4 rounded-md items-center justify-items-start shadow-sm"
          >
            <img
              class="h-[33%]"
              :src="getAsset('icons/clock-ticking-icon.svg')"
              alt="clock"
            />
            <span>
              {{ messageSLA }}
            </span>
          </div>
          <g-button
            class="mt-20"
            full
            variant="secondary"
            @click="onHome"
            data-test="button:Ir al home"
            >Ir al home</g-button
          >
        </section>
        <section class="hidden flex-col w-1/2 mb-8 gap-4 sm:flex">
          <p class="text-blue-13 font-semibold">
            Con tu cuenta Global Business también podrás:
          </p>
          <div
            v-for="(product, idx) in showProducts"
            :key="idx"
            class="flex flex-col gap-4"
          >
            <g-product-card :product="product" />
          </div>
        </section>
      </div>
    </template>
  </GStepGrid>
</template>
